import React from "react";
import "./../assets/css/login.css";
import bannerImage from "./../assets/banner/portada.jpg";
import { FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";
const Banner = () => {
  return (
    <div className="banner" style={{ backgroundImage: `url(${bannerImage})` }}>
      <div className="overlay"></div>
      <div className="banner-icons">
        <a href="https://www.facebook.com/share/16r3xKPXUq/" target="_blank" rel="noopener noreferrer">
          <FaFacebook className="icon" />
        </a>
        <a href="https://www.linkedin.com/company/h%C3%A1bitat-inclusi%C3%B3n/" target="_blank" rel="noopener noreferrer">
          <FaLinkedin className="icon" />
        </a>
        <a href="https://www.instagram.com/habitat_inclusion?igsh=MWdhc21oem0yN2NmZA==" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="icon" />
        </a>
      </div>
      <div className="banner-content"></div>

      <div className="banner-text">
        
        <div className="row">
          <div className="col-md-6 mb-5">
            <h2><strong>ARQUITECTURA CENTRADA EN LAS PERSONAS</strong></h2>
            <h3>
            Creemos en mejorar la calidad de vida de las personas mediante el diseño y un servicio centrado en ellas, contribuyendo a una
             sociedad más igualitaria, segura y accesible

            </h3>
          </div>{" "}
          <div className="col-md-6">
           
          </div>{" "}
        </div>
     
      </div>
    </div>
  );
};

export default Banner;